import {DateField as MuiDateField, DateFieldProps as MuiDateFieldProps} from '@mui/x-date-pickers'
import moment from 'moment'

import './styles.scss'

type DateFieldProps = MuiDateFieldProps<moment.Moment> & {
  minDate?: moment.Moment,
  maxDate?: moment.Moment,
  value?: moment.Moment,
  onChange?: (newValue: moment.Moment) => void
}

export const DateField: React.FC<DateFieldProps> = ({minDate, maxDate, value, onChange, ...rest}) => {
  return (
    <MuiDateField
      minDate={minDate}
      maxDate={maxDate}
      value={value}
      classes={{root: 'override-root-date-field-root'}}
      size='small'
      format='DD.MM.YYYY'
      onChange={(newValue) => onChange && onChange(newValue as unknown as moment.Moment)}
      {...rest}
    />
  )
}